var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.75H11.4062V1.65625C11.4062 1.30078 11.1055 1 10.75 1C10.4219 1 10.0938 1.30078 10.0938 1.65625V2.75H6.15625V1.65625C6.15625 1.30078 5.85547 1 5.5 1C5.11719 1 4.84375 1.30078 4.84375 1.65625V2.75H3.75C2.76562 2.75 2 3.54297 2 4.5V13.25C2 14.2344 2.76562 15 3.75 15H12.5C13.457 15 14.25 14.2344 14.25 13.25V4.5C14.25 3.54297 13.457 2.75 12.5 2.75ZM12.9375 13.25C12.9375 13.4961 12.7188 13.6875 12.5 13.6875H3.75C3.50391 13.6875 3.3125 13.4961 3.3125 13.25V6.25H12.9375V13.25ZM5.0625 11.5H7.6875C7.90625 11.5 8.125 11.3086 8.125 11.0625V8.4375C8.125 8.21875 7.90625 8 7.6875 8H5.0625C4.81641 8 4.625 8.21875 4.625 8.4375V11.0625C4.625 11.3086 4.81641 11.5 5.0625 11.5Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e18b1f0ea703965014fdde65386c5db9.svg";
export { ForwardRef as ReactComponent };